var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00066 16.2102L8.00066 7.79019C8.00018 7.45778 8.09385 7.13203 8.27082 6.85064C8.44779 6.56925 8.70084 6.34373 9.00066 6.20019C9.3564 6.03216 9.75219 5.96744 10.1429 6.01341C10.5337 6.05938 10.9036 6.21419 11.2107 6.46019L16.3107 10.6702C16.5013 10.8354 16.6542 11.0397 16.759 11.2691C16.8637 11.4986 16.918 11.7479 16.918 12.0002C16.918 12.2525 16.8637 12.5018 16.759 12.7312C16.6542 12.9607 16.5013 13.165 16.3107 13.3302L11.2107 17.5402C10.9036 17.7862 10.5337 17.941 10.1429 17.987C9.75219 18.0329 9.3564 17.9682 9.00066 17.8002C8.70084 17.6566 8.44779 17.4311 8.27082 17.1497C8.09385 16.8684 8.00018 16.5426 8.00066 16.2102Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/select-arrow.2d8f35f4b931d9e5929d5896ee3566f0.svg";
export { ForwardRef as ReactComponent };